<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Unofficial Hogwarts Cocktail Book, by Barmann" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781646043705/images/9781646043705.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>Spellbinding Spritzes, Fantastical Old Fashioneds, Magical Margaritas, and More Enchanting Recipes</p>
<p>The Unofficial Hogwarts Cocktail Book</p>
<p>Bertha Barmann</p>
<p>This book is not associated with or authorized or approved by J. K. Rowling, her publishers, or Warner Bros.</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?8c38fbd0